export default __webpack_public_path__ + "static/media/273.4cd74395.png";